import cx from "classnames";
import { useTranslation } from "next-i18next";
import React from "react";

import { ProgressBar } from "@/components/elements/ProgressBar";
import { FREE_SHIPPING_THRESHOLD } from "@/constants";
import { useCart } from "@/hooks/useCart";
import { calculateTotal } from "@/utils/cart";

export type CartFreeShippingProgressProps = {
  className?: string;
};

export const CartFreeShippingProgress = ({
  className,
}: CartFreeShippingProgressProps) => {
  const { cart } = useCart();
  const { t } = useTranslation();
  const { totalPrice, totalMissingTreshold } = calculateTotal(cart);
  const amountMissing = totalMissingTreshold / 100;
  const shippingCopy =
    totalMissingTreshold === 0
      ? t("shopping_cart_information")
      : t("cart_confirmation_description_other", { amountMissing });
  return (
    <ProgressBar
      className={cx(className)}
      currentStep={Math.min(totalPrice, FREE_SHIPPING_THRESHOLD)}
      totalSteps={FREE_SHIPPING_THRESHOLD}
      label={shippingCopy}
    />
  );
};
